module.exports = "<div class=\"mr10 ml10 bcp-impact-analysis-graph\" data-process-id={{impactAnalysisGraphVM.process.processId}}></div> ";